module.exports = __webpack_public_path__ + "static/media/as2tj64.d5f08b78.png";